import { SET_DATE_RANGE } from 'constants/ActionTypes';
import moment from 'moment';

const initialDateRange = {
  dateRange: {
    startDate: moment().subtract(2, 'month').startOf('month').format('YYYY-MM-DD'),
    endDate: moment().endOf('month').format('YYYY-MM-DD'),
  },
};

const date = (state = initialDateRange, action) => {
  switch (action.type) {
    case SET_DATE_RANGE:
      const startDate = moment(action.payload[0]).format('YYYY-MM-DD');
      const endDate = moment(action.payload[1]).format('YYYY-MM-DD');

      return {
        ...state,
        dateRange: {
          startDate,
          endDate,
        },
      };
    default:
      return state;
  }
};

export default date;
